import { render } from "./LevelThree.vue?vue&type=template&id=a38b6506"
import script from "./LevelThree.vue?vue&type=script&lang=js"
export * from "./LevelThree.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__